import React, { useState, useEffect } from "react";
import { Global } from "../helpers/Global";

export const CrearOrden = () => {
    const [clientes, setClientes] = useState([]);
    const [centros, setCentros] = useState([]);
    const [clienteSeleccionado, setClienteSeleccionado] = useState("");
    const [centrosSeleccionados, setCentrosSeleccionados] = useState([]);
    const [titulo, setTitulo] = useState("");
    const [descripcion, setDescripcion] = useState("");
    const [mensaje, setMensaje] = useState("");

    useEffect(() => {
        fetchClientes();
    }, []);

    useEffect(() => {
        if (clienteSeleccionado) {
            fetchCentros(clienteSeleccionado);
        } else {
            setCentros([]);
        }
    }, [clienteSeleccionado]);

    const fetchClientes = async () => {
        try {
            const res = await fetch(`${Global.url}clientes`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            });
            const data = await res.json();
            setClientes(data);
        } catch (err) {
            console.error("Error al cargar clientes:", err);
        }
    };

    const fetchCentros = async (clienteId) => {
        try {
            const res = await fetch(`${Global.url}centros/cliente/${clienteId}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            });
            const data = await res.json();
            setCentros(data);
        } catch (err) {
            console.error("Error al cargar centros:", err);
        }
    };

    const toggleCentro = (centroId) => {
        setCentrosSeleccionados((prev) =>
            prev.includes(centroId)
                ? prev.filter((id) => id !== centroId)
                : [...prev, centroId]
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!clienteSeleccionado || !titulo || !descripcion || centrosSeleccionados.length === 0) {
            setMensaje("Todos los campos son obligatorios.");
            return;
        }

        try {
            const resOrden = await fetch(`${Global.url}ordenes`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
                body: JSON.stringify({ cliente_id: clienteSeleccionado, titulo, descripcion }),
            });

            const dataOrden = await resOrden.json();

            if (!resOrden.ok) {
                setMensaje(dataOrden.message || "Error al crear la orden");
                return;
            }

            const resAsociacion = await fetch(`${Global.url}ordenes/asociar-centros`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
                body: JSON.stringify({
                    orden_id: dataOrden.data.id,
                    centros_id: centrosSeleccionados,
                }),
            });

            if (!resAsociacion.ok) {
                setMensaje("La orden fue creada, pero no se pudieron asociar los centros.");
                return;
            }

            setMensaje("✅ Orden creada y centros asociados correctamente");

            // Resetear formulario
            setTitulo("");
            setDescripcion("");
            setClienteSeleccionado("");
            setCentros([]);
            setCentrosSeleccionados([]);
        } catch (error) {
            console.error("Error al crear orden:", error);
            setMensaje("Error inesperado al crear la orden.");
        }
    };

    return (
        <div className="form-orden">
            <h2>Crear Nueva Orden de Trabajo</h2>
            {mensaje && <p className="mensaje">{mensaje}</p>}

            <form className="registro-fecha" onSubmit={handleSubmit}>
                <label>Título de la orden:</label>
                <input
                    className="input-layout"
                    type="text"
                    value={titulo}
                    onChange={(e) => setTitulo(e.target.value)}
                    placeholder="Título de la orden"
                />

                <label>Cliente:</label>
                <select
                    className="input-layout"
                    value={clienteSeleccionado}
                    onChange={(e) => setClienteSeleccionado(e.target.value)}
                >
                    <option value="">-- Selecciona un cliente --</option>
                    {clientes.map((cli) => (
                        <option key={cli.id} value={cli.id}>
                            {cli.nombre}
                        </option>
                    ))}
                </select>

                {centros.length > 0 && (
                    <>
                        <label>Centros de trabajo asociados:</label>
                        <div className="checkbox-group">
                            {centros.map((centro) => (
                                <label key={centro.id}>
                                    <input
                                        type="checkbox"
                                        value={centro.id}
                                        checked={centrosSeleccionados.includes(centro.id)}
                                        onChange={() => toggleCentro(centro.id)}
                                    />
                                    {centro.nombre}
                                </label>
                            ))}
                        </div>
                    </>
                )}

                <label>Descripción:</label>
                <textarea
                    className="input-layout"
                    value={descripcion}
                    onChange={(e) => setDescripcion(e.target.value)}
                    rows={4}
                    placeholder="Describe brevemente la orden de trabajo"
                ></textarea>

                <button type="submit" className="btn-login">
                    Crear Orden
                </button>
            </form>
        </div>
    );
};
